<template>
  <div>
    <div class="section-desc">
      {{ $t('매장 소개와 원산지 정보입니다. 원산지는 오더톡 매장 정보 페이지에 노출됩니다 (값이 있을 때만).') }}
    </div>

    <el-row>
      <el-col :md="24">
        <el-form-item :label="$t('원산지 표시')" :error="formError.originInfo">
          <el-input
            v-model="inputForm.originInfo"
            type="textarea"
            :rows="6"
            maxlength="2000"
            show-word-limit
            :placeholder="
              $t(
                '예) 쌀: 국내산 / 김치: 중국산 / 돼지고기: 국내산\n원산지를 비우면 qr2-web에서 항목 자체가 표시되지 않습니다.'
              )
            "></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['value', 'formError'],
  computed: {
    inputForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
}
</script>

<style scoped>
.el-col {
  padding: 4px;
}
.section-desc {
  color: #909399;
  font-size: 13px;
  margin-bottom: 8px;
  padding: 0 4px;
}
</style>
